
import React, { Component } from 'react';
import FormContainer from '../form/FormContainer';
import * as Utils from '../../utils/utils';
import { trackingWrapper } from '../../utils/analytics';

//import Game from './game/Game';

import './../../../scss/App.scss';


class UnlockPuzzlePanel extends Component {

	constructor(props){
		super(props);

		this.state = {
			"hasSubscribed": false,
			"hasSubmitted": false,
			"day": window.ppz.puzzleToUnlock.day,
			"title": window.ppz.puzzleToUnlock.title,
			"isLocked": window.ppz.puzzleToUnlock.isLocked
		}

		//

		this.handleVideoOption = this.handleVideoOption.bind(this);

	}

	componentDidMount(){
		window.TweenMax.set(this.refs.panel, {transform:"translateY(10vh)"});
		window.TweenMax.to(this.refs.panel, 1, {transform:"translateY(0vh)"});
	}

	componentDidUpdate(prevProps, prevState){
		if(prevState.hasSubmitted === false && this.state.hasSubmitted === true){
			Utils.unlockPuzzlesSetCookies(this.state.day);
			window.ppz.app.initPuzzleDay(this.state.day);

			/*
			this.setState({
				"isLocked":false
			});
			*/
		}
	}

	handleVideoOption(){
		// tracking
		trackingWrapper('event', 'PPZgame-newsletter-watch-video-instead', {'event_category':'people-puzzler-game'});

		window.ppz.gamePage.showVideoAd("unlockPuzzle");
		window.ppz.overlayManager.closeOverlay();
	}

	handlePuzzleSelection(){
		if(this.state.isLocked === false){
			window.ppz.app.initPuzzleDay(this.state.day);
		}
	}

	render(){
		const { hasSubscribed, hasSubmitted } = this.state;

		let dayActive = "";
		if(this.state.isLocked === false){
			dayActive = " active";
		}

		return (
			<div id="unlockPuzzlePanel" ref="panel">
				<div className="heading">
					<div className={"puzzleBtn" + dayActive} onClick={() => this.handlePuzzleSelection()}>
						<span className="locked fa-solid fa-lock"></span>
						<span className="unlocked fa-solid fa-lock-open"></span>
						{this.state.title}
					</div>
				</div>
				{hasSubmitted ?
					<div className="body">
						<div className="line thankYouMsg">Thanks for Subscribing! <br/> You've unlocked this puzzle!</div>
					</div>	
				:
					<div>
						<div className="body">
							<div className="line">Unlock this puzzle by subscribing to our newsletter or by watching a short video!</div>
								<FormContainer 

									//returns showNewsletter=false on mount if the user has submitted a newsletter within 45 days
									handleShowNewsletter={hasNotSubscribed=>{
										console.log('hasNotSubscribed', hasNotSubscribed);
										this.setState({hasSubscribed: !hasNotSubscribed});
									}}

									//callback when newsletter has been successfully submitted
									handleNewsletterSubmit={()=>{
										console.log('handleNewsletterSubmit');
										this.setState({hasSubmitted: true, hasSubscribed: true});
									}}

									//submit button label
									submitLabel="Unlock"
								/>
						</div>
						<div className="footer">
							<div className="videoOption" onClick={() => this.handleVideoOption()}>Watch A Video Instead</div>
						</div>
					</div>
				}
				
				<div className="closeBtn" onClick={() => window.ppz.overlayManager.closeOverlay()}>
					<div className="x"></div>
				</div>
			</div>
		);
	}
}

export default UnlockPuzzlePanel;


// WEBPACK FOOTER //
// ./src/js/components/overlays/UnlockPuzzlePanel.js